import { EFlatRoomCounts } from 'shared/common/utils/types';
import { IFormFieldUI } from '../types/formFields';

export const roomsCountSelectorOptions: IFormFieldUI<EFlatRoomCounts>['values'] = {
  [EFlatRoomCounts.Studio]: {
    label: 'Студия',
    selectedLabel: 'Студия',
    value: EFlatRoomCounts.Studio,
  },
  [EFlatRoomCounts.OneRoom]: {
    label: '1',
    selectedLabel: '1 комн.',
    value: EFlatRoomCounts.OneRoom,
  },
  [EFlatRoomCounts.TwoRoom]: {
    label: '2',
    selectedLabel: '2 комн.',
    value: EFlatRoomCounts.TwoRoom,
  },
  [EFlatRoomCounts.ThreeRoom]: {
    label: '3',
    selectedLabel: '3 комн.',
    value: EFlatRoomCounts.ThreeRoom,
  },
  [EFlatRoomCounts.FourRoom]: {
    label: '4+',
    selectedLabel: '4+ комн.',
    value: EFlatRoomCounts.FourRoom,
  },
};

export const sortRuleRoomsCount = [
  EFlatRoomCounts.Studio,
  EFlatRoomCounts.OneRoom,
  EFlatRoomCounts.TwoRoom,
  EFlatRoomCounts.ThreeRoom,
  EFlatRoomCounts.FourRoom,
];
